import { useMutation } from "@tanstack/react-query"
import { verifyPhone } from "@/api"

export const useVerifyPhone = () => {
  return useMutation({
    mutationFn: ({ otp }: { otp: string }) => verifyPhone({ otp }),
  })
}
